import type {
  FormbrewEmbedErrorDetail,
  FormbrewEmbedEventMap,
  FormbrewEmbedReadyDetail,
  FormbrewEmbedSuccessDetail,
} from "./embed.types.ts";

type FormbrewEmbedEventDetail =
  | FormbrewEmbedErrorDetail
  | FormbrewEmbedReadyDetail
  | FormbrewEmbedSuccessDetail;

export const dispatchFormbrewEvent = <TEventName extends keyof FormbrewEmbedEventMap>(
  target: HTMLElement,
  name: TEventName,
  detail: FormbrewEmbedEventDetail,
): void => {
  target.dispatchEvent(
    new CustomEvent(name, {
      bubbles: true,
      composed: true,
      detail,
    }),
  );
};
